import { render, staticRenderFns } from "./ReSearchMObjBig.vue?vue&type=template&id=120bd8aa&scoped=true"
import script from "./ReSearchMObjBig.vue?vue&type=script&lang=js"
export * from "./ReSearchMObjBig.vue?vue&type=script&lang=js"
import style0 from "./ReSearchMObjBig.vue?vue&type=style&index=0&id=120bd8aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120bd8aa",
  null
  
)

export default component.exports